import getEnvironmentVariables from '@/config/environment';

export function buildBentoboxApiEndpoint(endpoint: string): string {
  const { ENVIRONMENT_NAME } = getEnvironmentVariables();

  let formattedEndpoint = endpoint;
  if (ENVIRONMENT_NAME === 'development' || ENVIRONMENT_NAME === 'CI') {
    if (formattedEndpoint.includes('https')) {
      formattedEndpoint = formattedEndpoint.replace('8080', '8000');
    } else {
      formattedEndpoint = `https://${window.location.hostname.split('.')[0]}.localtest.me:8000${formattedEndpoint}`;
    }

    // To support integration tests, ci-port query string will be included on the new URL.
    const params = new URLSearchParams(window.location.search);
    if (params.has('ci-port')) {
      let ciPort = params.get('ci-port');
      formattedEndpoint = formattedEndpoint.replace('8000', `${ciPort}`);
    }
  }

  return formattedEndpoint;
}
